import { render, staticRenderFns } from "./pane.vue?vue&type=template&id=480ea119&scoped=true&"
import script from "./pane.vue?vue&type=script&lang=ts&"
export * from "./pane.vue?vue&type=script&lang=ts&"
import style0 from "./pane.vue?vue&type=style&index=0&id=480ea119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ea119",
  null
  
)

export default component.exports